/*
 *   Copyright (c) 2021 vlinder Inc.
 *   All rights reserved.
 *   This software is proprietary of vlinder Inc. and can not be distributed / used for any purpose outside of vlinder Inc. without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React, { lazy, Suspense } from 'react';
import { BrowserRouter, useRoutes, RouteObject } from 'react-router-dom';
import { StorageModule } from '@vlinder-web/storage-module-react';
import { getLandingPageRoute } from '@pages/LandingPage';
import { getProfilePageRoute } from '@pages/Profile';
import { getPlaceholderPageRoute } from '@pages/Placeholder';
import ScrollToTop from './ScrollToTop';
import { useSMAppNavigator } from './machines/pageContent';
import { getSignInPageRoute } from '@pages/SignIn';
import { getMyAccountPageRoute } from '@pages/MyProfile';
import { getOrganizationPageRoute } from '@pages/OrganizationProfile';
import { getSuppliersPageRoute } from '@pages/Suppliers';
import { getOrgCompliancePageRoute } from '@pages/OrgComplianceList';
import { getOrgComplianceDetailPageRoute } from '@pages/OrgComplianceDetail';
import { getBulkImportPageRoute } from '@pages/BulkImport';
import { getSupplyChainListPageRoute } from '@pages/SupplyChainList';
import { getSupplyStepperPageRoute } from '@pages/SupplyStepper';
import { getSupplyChainTemplatePageRoute } from '@pages/SuplyChainTemplate';
import { getSuppChainTempOverViewPageRoute } from '@pages/SupplyChainTemplateOverView';
import { getSuppChainTransPageRoute } from '@pages/SuppChainTransactions';
import { getAnalyticsPageRoute } from '@pages/Analytics';
import { getSupplyChainTransOverviewPageRoute } from '@pages/SupplyChainTransOverview';
import { getCampaignListPageRoute } from '@pages/CampaignList';
import { getNewCampaignPageRoute } from '@pages/NewCampaign';
import { getBatchSerializationListPageRoute } from '@pages/BatchSerializationList';
import { getNewBatchSerializationPageRoute } from '@pages/NewBatchSerialization';
import { getSuppliersCompliancePageRoute } from '@pages/SupplierCompliance';
import { getDistillersPageRoute } from '@pages/Distillers';
import { getDistillersDetailPageRoute } from '@pages/DistillersDetail';
import { getDistillerDetailListPageRoute } from '@pages/DistillerDetailList';
import { getPlantListPageRoute } from '@pages/PlantList';
import { getProductListPageRoute } from '@pages/ProductList';
import { getSuppChainTransDetailPageRoute } from '@pages/SuppChainTransactionDetail';

const _handleDropDownItemClick = (item: any) => {
  const storageSrv = StorageModule?.getInstance();
  if (item.id === 'logout') {
    storageSrv.reset('session');
    storageSrv.reset('local');
    window.open('/', '_self');
  }
};

export const AppNavigator = (): JSX.Element => {
  const { appNavigatorSend, appNavigatorState, appNavigatorMachine } =
    useSMAppNavigator({});

  if (appNavigatorState?.matches('RENDER_PAGE')) {
    const {
      brandLogo,
      brandLogoLink,
      brandTitle,
      sidebarItems,
      routes,
      orgName,
      orgUrl,
      copyrightStartYear,
      whoami,
      userName,
      userImage,
      dropdownItems,
      footerSection,
    } = { ...(appNavigatorState?.event?.data?.value || {}) };
    const props = {
      brandLogo,
      brandLogoLink,
      brandTitle,
      items: sidebarItems,
      routes,
      orgName,
      orgUrl,
      copyrightStartYear,
      whoami,
      userName,
      userImage,
      dropdownItems,
      footerSections: footerSection,
      onDropDownItemClick: _handleDropDownItemClick,
    };

    const getAllRoutes = (): RouteObject[] => {
      return [
        getLandingPageRoute(props),
        getProfilePageRoute(props),
        getPlaceholderPageRoute(props),
        getSignInPageRoute(props),
        getMyAccountPageRoute(props),
        getOrganizationPageRoute(props),
        getSuppliersPageRoute(props),
        getOrgCompliancePageRoute(props),
        getOrgComplianceDetailPageRoute(props),
        getBulkImportPageRoute(props),
        getSupplyChainListPageRoute(props),
        getSupplyStepperPageRoute(props),
        getSupplyChainTemplatePageRoute(props),
        getSuppChainTempOverViewPageRoute(props),
        getSuppChainTransPageRoute(props),
        getAnalyticsPageRoute(props),
        getSupplyChainTransOverviewPageRoute(props),
        getCampaignListPageRoute(props),
        getNewCampaignPageRoute(props),
        getBatchSerializationListPageRoute(props),
        getNewBatchSerializationPageRoute(props),
        getSuppliersCompliancePageRoute(props),
        getDistillersPageRoute(props),
        getDistillersDetailPageRoute(props),
        getDistillerDetailListPageRoute(props),
        getPlantListPageRoute(props),
        getProductListPageRoute(props),
        getSuppChainTransDetailPageRoute(props),
      ];
    };

    const RouterConfig = () => {
      const routes = useRoutes(getAllRoutes());
      return routes;
    };
    return (
      <BrowserRouter>
        <ScrollToTop />
        <Suspense fallback={<div></div>}>
          <RouterConfig />
        </Suspense>
      </BrowserRouter>
    );
  }
  if (appNavigatorState?.matches('GET_PAGE_CONTENT')) {
    return <div />;
  }
  return <></>;
};
